export const isArrayItem = (list, item) => {
    const jsonString = JSON.stringify(item);
    return list.some((listItem) => {
        try {
            // Use strict equality check to ensure type safety
            if (typeof listItem === "object" && typeof item === "object") {
                return JSON.stringify(listItem) === jsonString;
            }
            else {
                return listItem === item;
            }
        }
        catch (_error) {
            // Ignore errors in case of circular references or other stringify issues
            return false;
        }
    });
};
export default {
    isArrayItem
};
